import React, { useEffect, useState, Fragment } from "react";
import { Combobox, Transition, Listbox } from "@headlessui/react";
import {
  CheckIcon,
  ChevronDoubleDownIcon,
  ChevronDownIcon,
} from "@heroicons/react/solid";
import PrimaryButton from "ui/buttons/PrimaryButton";

export default function ComboBoxComponent({
  values,
  options,
  selectedValue,
  placeholder,
}) {
  const [query, setQuery] = useState("");
  const [data, setData] = useState(values);

  React.useEffect(() => {
    setData(values);
  }, [values]);

  let filteredData =
    query === ""
      ? data
      : data.filter((item) => {
          let selectedData = item?.name
            ?.toLowerCase()
            .replace(/\s+/g, "")
            .includes(query.toLowerCase().replace(/\s+/g, ""));
          return selectedData;
        });

  return (
    <div className=" w-full">
      <div className=" w-full border rounded-md border-gray-300 px-1 flex justify-between cursor-default overflow-hidden  bg-white text-left  focus:outline-none  ">
        <Combobox.Input
          className="w-full rounded-md border-none py-1 px-4 focus:outline-none bg-white  text-sm leading-5 text-gray-900 focus:ring-0"
          displayValue={(value) => value?.name}
          onChange={(event) => setQuery(event.target.value)}
          placeholder={placeholder}
        />
        <Combobox.Button className=" inset-y-0 right-0 flex items-center  ">
          <ChevronDoubleDownIcon
            className="h-3 w-3 text-gray-400"
            aria-hidden="true"
          />
        </Combobox.Button>
      </div>
      <Transition
        as={Fragment}
        leave="transition ease-in duration-100"
        leaveFrom="opacity-100"
        leaveTo="opacity-0"
        afterLeave={() => setQuery("")}
      >
        <Combobox.Options
          className=" rounded-md shadow-md max-w-sm
          z-50 mt-1  border border-gray-200 max-h-60 w-full overflow-auto bg-white   py-1 text-md "
        >
          {filteredData.length === 0 && query !== "" ? (
            <div className=" cursor-default select-none py-3 px-4 text-gray-700">
              Nothing found.
            </div>
          ) : (
            <>
              {filteredData.map((item) => (
                <Combobox.Option
                  key={item?.id}
                  className={({ active }) =>
                    ` cursor-pointer divide-y divide-gray-100  select-none px-1 ${
                      active ? "bg-slate-200 text-black" : "text-gray-900"
                    }`
                  }
                  value={item}
                >
                  {({ selected, active }) => (
                    <div className="flex py-2 flex-row space-x-2 justify-start items-start">
                      {selected ? (
                        <span
                          className={`flex  justify-center items-center ${
                            active ? "text-white" : "text-teal-800"
                          }`}
                        >
                          <CheckIcon className="h-5 w-5 " aria-hidden="true" />
                        </span>
                      ) : (
                        <div className="h-5 w-5"></div>
                      )}

                      <div
                        className={`w-full divide-y text-sm divide-gray-100  ${
                          selected ? "font-medium " : "font-normal "
                        }`}
                      >
                        {options(item) ?? item?.name}
                      </div>
                    </div>
                  )}
                </Combobox.Option>
              ))}
            </>
          )}
        </Combobox.Options>
      </Transition>
    </div>
  );
}
